import { render, staticRenderFns } from "./DoctorFilterPanel.vue?vue&type=template&id=955b909e&scoped=true&"
import script from "./DoctorFilterPanel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorFilterPanel.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorFilterPanel.vue?vue&type=style&index=0&id=955b909e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955b909e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('955b909e')) {
      api.createRecord('955b909e', component.options)
    } else {
      api.reload('955b909e', component.options)
    }
    module.hot.accept("./DoctorFilterPanel.vue?vue&type=template&id=955b909e&scoped=true&", function () {
      api.rerender('955b909e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorFilterPanel/DoctorFilterPanel.vue"
export default component.exports